import React, { useEffect, useState, useRef } from 'react';
import { useHistory  } from 'react-router-dom';
import Loader from '../global/loader';
import swal from 'sweetalert2';
import { NavLink } from 'react-router-dom';
import bannerLogo from '../../assets/images/OGR_Login_logo.png';
import { getCashCardData, postCashCardPayment, cancelCashCardTransaction } from '../api/cashCardAPI';

const CashCard = () => {
    const navigate = useHistory();
    const [loading, setLoading] = useState(false);
    const [pageData, setPageData] = useState(null);
    const [selectedCashCard, setSelectedCashCard] = useState(null);
    const [timeRemaining, setTimeRemaining] = useState('00:00');
    const [dataParam, setDataParam] = useState(null);
    const [signParam, setSigParam] = useState(null);
    const [isApp, setIsApp] = useState(false);
    const timerRef = useRef(null); 
    const cancelTriggeredRef = useRef(false);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const data = params.get('data');
        const sig = params.get('sig');
        const app = params.get("app") === "1";

        if (!data || !sig) {
            showAlertAndRedirect("error", app, "failed", "Invalid payment URL!", "Required parameters are missing. Session Expired.",false);
        }else{
            setDataParam(data);
            setSigParam(sig);
        }

        if (app) {
            setIsApp(app);
        }

        loadCashCardData(app,data,sig);
        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, []);

    useEffect(() => {
        if (!pageData?.PaymentTimeOut) return;
        
        const endTs = getSafeTimestamp(pageData.PaymentTimeOut);
        if (!endTs) {
            setTimeRemaining('00:00');
            return;
        }
        
        if (timerRef.current) clearInterval(timerRef.current);
    
        tick(endTs);
        timerRef.current = setInterval(() => tick(endTs), 1000);
    }, [pageData?.PaymentTimeOut]);

    const loadCashCardData = async (app,data,sig) => {
        try {
            setLoading(true);
            const ccData = await getCashCardData(data, sig);
            if (ccData?.CashCardList?.length === 0) {
                showAlertAndRedirect("error",app,"failed","Error!", "No cash cards available for your account. Please contact support.",false);
            }
            setPageData(ccData);
            setSelectedCashCard(ccData.CashCardList[0]);
            setLoading(false);
        } catch (err) {
            showAlertAndRedirect("error",app,"failed","Failed to load cash card data!", err?.message,false);
        }
    };

    function getSafeTimestamp(input) {
        if (input instanceof Date) return input.getTime();
        if (typeof input === 'number') return input;
        if (typeof input === 'string') {
            let s = input.trim();
            // handle 'YYYY-MM-DD HH:mm:ss' → 'YYYY-MM-DDTHH:mm:ss'
            if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(s)) {
            s = s.replace(' ', 'T');
            }
            const ts = Date.parse(s);
            return Number.isNaN(ts) ? null : ts;
        }
        return null;
    }
    
    function tick(targetTs) {
        const diff = targetTs - Date.now();
        if (diff <= 0) {
            setTimeRemaining('00:00');
            clearInterval(timerRef.current);
            timerRef.current = null;
    
            if (!cancelTriggeredRef.current) {
                cancelTriggeredRef.current = true;
                handleCancelTransaction("timeout");
            }
            // if (cancelTriggeredRef.current) return;
            // cancelTriggeredRef.current = true;
            return;
        }
        const mins = Math.floor(diff / 60000);
        const secs = Math.floor((diff % 60000) / 1000);
        setTimeRemaining(
            `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
        );
    }

    const handleCardSelection = (cardIndex) => {
        if (pageData && pageData.CashCardList) {
            setSelectedCashCard(pageData.CashCardList[cardIndex]);
        }
    };

    const sendMessageToFlutter = (msg) => {
        if (window.Flutter && window.Flutter.postMessage) {
            window.Flutter.postMessage(msg);
            return true;
        }
        return false;
    };

    const handleMakePayment = async () => {
        if (!selectedCashCard || !pageData) return;

        try {
            setLoading(true);
            swal.fire({
                titleText: 'Loading',
                text: 'Processing payment response...',
                showConfirmButton: false,
                allowOutsideClick: false,
                didOpen: () => {
                    swal.showLoading();
                }
            });
            const result = await postCashCardPayment(dataParam, signParam, selectedCashCard.CardNo);
            const iconType = result?.Message?.toLowerCase() === 'success' ? 'success' : 'error';
            const status = result?.Message?.toLowerCase() === 'success' ? 'success' : 'failed';
            const titleMsg = result?.Message?.toLowerCase() === 'success' ? "Payment Successful" : "Payment Failed";
            showAlertAndRedirect(iconType , isApp, status, titleMsg, `Transaction ID: ${result?.TransactionID}`);
            setLoading(false);
        } catch (err) {
            setLoading(false);
            showAlertAndRedirect("error",isApp,"failed","Payment Failed!", err?.message,false);
        }
    };

    const triggerCancellationPopup = () => {
        swal.fire({
            icon: 'warning',
            titleText: 'Are you sure, you want to cancel your Tee Booking?',           
            showCancelButton: true,
            confirmButtonText: 'Yes',           
            cancelButtonText:'No'
        }).then(async(res) => {
            if (res.isConfirmed) {
                handleCancelTransaction();
                return;
            }
        });
    }

    const showAlertAndRedirect = ( icon = "error", app = false, status, titleMsg , textMsg = "", isRedirect=true) => {
        swal.fire({
            icon: icon,
            titleText: titleMsg,
            text: textMsg,
            showConfirmButton: true,
            confirmButtonText: 'OK',
            allowOutsideClick: false
        }).then(() => {
            if(isRedirect)
            redirection(app, status, titleMsg, textMsg);
        });
    };

    const redirection = (appView, status, message, desc="") => {
        if (appView) {
            sendMessageToFlutter(
                JSON.stringify({ Status: status, Message: message, Description: desc })
            );
            return;
        }

        const path = status === "success" ? "/my-booking" : "/tee-booking";

        setTimeout(() => navigate.push(path), 800);
    };

    const handleCancelTransaction = async (reason = "user") => {
        // if (!pageData) return;
        try {
            setLoading(true);
            const result = await cancelCashCardTransaction(dataParam, signParam);
            let titleMsg = result?.Message?.toLowerCase() === 'success' ? (reason === "timeout" ? "Session expired. TeeTime was auto-cancelled." : "TeeTime Cancelled Successfully") : "TeeTime Cancellation Failed";
            let iconType = result?.Message?.toLowerCase() == "success" ? (reason === "timeout" ? 'error' : 'success') : 'error';
            let status = result?.Message?.toLowerCase() == "success" ? "cancelled" : "failed";
            let textMsg = result?.LongMessage + ` Transaction ID: ${result?.TransactionID}`;
            showAlertAndRedirect(iconType, isApp, status, titleMsg, textMsg);
            setLoading(false);
        } catch (err) {
            setLoading(false);
            showAlertAndRedirect("error",isApp,"failed","Failed to Cancel Transaction!", err?.message,false);
        }
    };

    if (loading && !pageData) {
        return <Loader />;
    }

    return (
        <>
            {/* Navigation */}
            <nav className="navbar navbar-default" role="navigation">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-10 padding-lr0">
                            <div className="navbar-brand">
                                <NavLink to="/">
                                    <img id="asideBrandLogo" alt="Logo" src={bannerLogo} height="35" />
                                </NavLink>
                                <div>Oxford Golf Resort<small> Tee Time Booking</small></div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            <div className="container">
                <div className="row margin-t10">
                    <div className="col-xs-12">
                        <div id="messageHolder"></div>
                    </div>
                    <div className="col-xs-12">
                        <h6 className="text-muted text-center sticky-format">
                            <i className="fa fa-clock-o" aria-hidden="true"></i> Time Remaining: <b id="txtCountDown">{timeRemaining}</b>
                        </h6>
                    </div>
                </div>
                
                <div className="row margin-t10">
                    <div className="col-xs-12">
                        <div className="panel panel-default panel-match wow fadeInUp animated" data-wow-delay="0.1s">
                            <div className="panel-heading text-center">SELECTED CASH CARD</div>
                            <div className="panel-body">
                                <div className="row padding-10">
                                    <div className="col-xs-5">
                                        <h5>
                                            <span id="txtCardNumber">
                                                {selectedCashCard ? `${selectedCashCard.CardNo.slice(0, 3)}XXXXX` : ''}
                                            </span>
                                            <br/>
                                            <small className="text-muted">Card Number</small>
                                        </h5>
                                    </div>
                                    <div className="col-xs-7">
                                        <h4 className="margin-0 text-right">₹ 
                                            <span id="txtCardAmount">
                                                {selectedCashCard ? selectedCashCard.CardAmt : '0'}
                                            </span>
                                            <br />
                                            <small>Available Balance</small>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <h6 className="text-muted text-center text-uppercase sticky-format">
                            <b>Select Cash Card</b>
                        </h6>
                        
                        {pageData && pageData.CashCardList && pageData.CashCardList.map((card, index) => (
                            <div key={index} className="panel panel-default panel-match wow fadeInUp animated" data-wow-delay="0.1s">
                                <div className="panel-heading">{card.CardNo.substring(0, 3)}XXXXX</div>
                                <div className="panel-body">
                                    <div className="row padding-tb10">
                                        <div className="col-xs-8">
                                            <h5 className="margin-0">₹ {card.CardAmt}</h5>
                                        </div>
                                        <div className="col-xs-4 text-right padding-r20">
                                            <input
                                                id={`card${index + 1}`}
                                                type="radio"
                                                name="cashCardOptions"
                                                checked={!!selectedCashCard && selectedCashCard.CardNo === card.CardNo}
                                                onChange={() => handleCardSelection(index)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        
                        <div className="col-xs-12 btn-action margin-t30 padding-t30">
                            <h5 className="text-right margin-0 padding-r5">
                                <b>INR {pageData ? pageData.Amount : '0'}</b>
                            </h5>
                            <div className="text-right">
                                <small className="padding-r5">(Total Amount Payable)</small><br />
                                <button
                                    id="btnSave"
                                    type="button"
                                    className="btn btn-success margin-l15 margin-t5 pull-right"
                                    onClick={handleMakePayment}
                                    disabled={loading || timeRemaining == "00:00"}
                                >
                                    Make Payment
                                </button>
                                <button 
                                    id="btnCancel" 
                                    type="button" 
                                    className="btn btn-default pull-right margin-t5"
                                    onClick={triggerCancellationPopup}
                                    disabled={loading}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* {loading && <Loader />} */}
        </>
    );
};

export default CashCard;